import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import aikoLogo from '../assets/logos/aiko.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  // Navigation links
  const navLinks = [
  ];

  // Change header style on scroll and hide/show based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show header only at the top of the page (less than 50px)
      if (currentScrollY <= 50) {
        setIsVisible(true);
        setIsScrolled(false);
      } else {
        setIsVisible(false);
        setIsScrolled(true);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <motion.header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'py-3 bg-white/10 backdrop-blur-md shadow-lg' 
          : 'py-5 bg-transparent'
      }`}
      initial={{ y: 0 }}
      animate={{ y: isVisible ? 0 : -100 }}
      transition={{ duration: 0.3 }}
    >
      <div className="container-custom flex items-center justify-between">
        {/* Logo */}
        <motion.a 
          href="/"
          className="flex items-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <img 
            src={aikoLogo} 
            alt="Aiko Logo" 
            className="h-14 w-auto"
          />
        </motion.a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          {navLinks.map((link, index) => (
            <motion.a
              key={link.name}
              href={link.href}
              className="text-white hover:text-ocean-300 transition-colors font-medium text-sm"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              {link.name}
            </motion.a>
          ))}
          <motion.a
            onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="px-5 py-2 rounded-[40px] bg-white text-[#222] font-medium hover:bg-white group transition-all duration-300 shadow-lg text-sm relative overflow-hidden"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: navLinks.length * 0.1 }}
          >
            <span className="relative z-10 group-hover:text-[#5046E5] transition-colors duration-300">Demander un devis</span>
            <span className="absolute inset-0 bg-white z-0 group-hover:bg-white transition-colors duration-300"></span>
          </motion.a>
        </nav>

        {/* Mobile "Demander un devis" button */}
        <motion.a
          onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
          className="md:hidden px-4 py-1.5 rounded-[40px] bg-white text-[#222] font-medium hover:bg-white group transition-all duration-300 shadow-lg text-xs relative overflow-hidden"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <span className="relative z-10 group-hover:text-[#5046E5] transition-colors duration-300">Demander un devis</span>
          <span className="absolute inset-0 bg-white z-0 group-hover:bg-white transition-colors duration-300"></span>
        </motion.a>
      </div>
    </motion.header>
  );
};

export default Header;
